import { FormBase } from 'core/components';

export default class AssignCarrierServiceAndWarehouseForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'assignedCarrierServiceId',
					label: 'FULFILLMENTORDER.ASSIGNMODAL.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'assignedWarehouseId',
					label: 'FULFILLMENTORDER.ASSIGNMODAL.WAREHOUSE',
					rules: 'required',
				},
				{
					name: 'useBuyShipping',
					label: 'FULFILLMENTORDER.ASSIGNMODAL.USEBUYSHIPPING',
					type: 'checkbox',
				},
				{
					name: 'ignoreDeliverByDate',
					type: 'checkbox',
					label: '',
				},
				{
					name: 'ltlCarrierId',
					label: 'FULFILLMENTORDER.ASSIGNMODAL.LTLCARRIER',
				},
			],
		};
	}
}
